/**
 * Clé publique VAPID des notifications push.
 * Doit correspondre à `preconys.commons.vapid.public-key` côté backend (domain-api).
 */
export const VAPID_PUBLIC_KEY =
  'BCGPYvFicpwI_BWuCDqSMJV8Vx2Pw9s17m4EtlyvDGT13IFIOQ7a_ZCGgFB_DyTFrUEl58Njv2quaURVmhyrUXU';
